(() => {
  'use strict';

  const configNode = document.getElementById('ProductExperienceTelemetryConfig');
  if (!configNode || !window.Shopify?.analytics?.publish) return;

  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  if (!config?.pilot_id || !config?.product_id) return;

  const root = document.getElementById('MainContent') || document.querySelector('main');
  if (!root) return;
  const eventName = 'inspire_hardware:experience';
  const sectionState = new WeakMap();
  let sequence = 0;

  const clean = (value, max = 120) => String(value || '').replace(/\s+/g, ' ').trim().slice(0, max);
  const slug = (value) => clean(value, 80).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'unknown';
  const selectedVariant = () => {
    const id = document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || '';
    const sku = document.querySelector('[data-variant-sku]:not([hidden])')?.dataset.variantSku || config.sku || '';
    return { variant_id: clean(id, 32), sku: clean(sku, 80) };
  };
  const publish = (eventType, details = {}) => {
    const variant = selectedVariant();
    window.Shopify.analytics.publish(eventName, {
      pilot_id: config.pilot_id,
      theme_id: config.theme_id,
      event_type: eventType,
      page_type: 'product',
      page_path: location.pathname,
      product_id: String(config.product_id),
      product_handle: config.product_handle,
      variant_id: variant.variant_id,
      sku: variant.sku,
      sequence: ++sequence,
      ...details
    });
  };

  const categoryFor = (node) => {
    if (node.matches('product-info, [id^="shopify-section-template--"][id$="__main"]')) return 'purchase';
    if (node.querySelector('.product-document-viewer, [data-product-document-viewer]')) return 'product_resources';
    if (node.querySelector('.comparison-section')) return 'brand_comparison';
    if (node.querySelector('.product-faq-tabs, .faqtab')) return 'faq';
    if (node.querySelector('.jdgm-widget, [data-product-review-tiles]')) return 'reviews';
    if (node.querySelector('product-recommendations, complementary-products')) return 'recommendations';
    return slug(node.dataset.sectionType || node.id || node.className);
  };
  const sections = [...root.querySelectorAll('.shopify-section, product-info')].filter((node, index, all) =>
    !all.some((other) => other !== node && other.contains(node) && other.tagName === 'PRODUCT-INFO')
  );
  sections.forEach((node, index) => {
    const sectionId = slug(node.dataset.sectionType || node.id || `section-${index + 1}`);
    node.dataset.telemetrySection = sectionId;
    node.dataset.telemetryCategory = categoryFor(node);
    sectionState.set(node, { visibleAt: 0, visits: 0, qualified: false });
  });

  const observer = new IntersectionObserver((entries) => {
    const now = Date.now();
    entries.forEach((entry) => {
      const state = sectionState.get(entry.target);
      if (!state) return;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        if (state.visibleAt) return;
        state.visibleAt = now;
        state.qualified = false;
        setTimeout(() => {
          if (!state.visibleAt || state.qualified || Date.now() - state.visibleAt < 900) return;
          state.qualified = true;
          state.visits += 1;
          publish('section_view', {
            section_id: entry.target.dataset.telemetrySection,
            section_category: entry.target.dataset.telemetryCategory,
            section_position: sections.indexOf(entry.target) + 1,
            visit_number: state.visits
          });
        }, 950);
      } else if (state.visibleAt) {
        const dwell = now - state.visibleAt;
        if (state.qualified) publish('section_dwell', {
          section_id: entry.target.dataset.telemetrySection,
          section_category: entry.target.dataset.telemetryCategory,
          dwell_ms: Math.min(dwell, 30 * 60 * 1000),
          visit_number: state.visits
        });
        state.visibleAt = 0;
        state.qualified = false;
      }
    });
  }, { threshold: [0, 0.5] });
  sections.forEach((node) => observer.observe(node));

  root.addEventListener('click', (event) => {
    const target = event.target.closest('a, button, summary, label[for], [role="button"]');
    if (!target) return;
    const section = target.closest('[data-telemetry-section]');
    const href = target.closest('a[href]')?.getAttribute('href') || '';
    let targetPath = '';
    try { const url = new URL(href, location.origin); if (url.origin === location.origin) targetPath = url.pathname; } catch {}
    publish('section_action', {
      section_id: section?.dataset.telemetrySection || 'unassigned',
      section_category: section?.dataset.telemetryCategory || 'unassigned',
      action_type: href ? 'link_click' : target.matches('summary, label[for]') ? 'expand' : 'button_click',
      element_type: target.tagName.toLowerCase(),
      element_label: clean(target.getAttribute('aria-label') || target.textContent || target.title, 100),
      target_path: targetPath
    });
  }, true);

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    const now = Date.now();
    sections.forEach((node) => {
      const state = sectionState.get(node);
      if (state?.visibleAt && state.qualified) publish('section_dwell', {
        section_id: node.dataset.telemetrySection,
        section_category: node.dataset.telemetryCategory,
        dwell_ms: Math.min(now - state.visibleAt, 30 * 60 * 1000),
        visit_number: state.visits
      });
    });
  });
})();
